export class RequiredDocuments{
    name?:string;
    type?:string;
    documentBase64?:string;
    uid:string;
    size:number;
    sizeInKbs:number;
    id: number;
    uploaded: boolean;
    received: boolean;
    required: boolean;
    IsCommerceFile?: boolean = false;
    IsUploadedTrue?: boolean = false;
    documentType?: string;
}
